import { CustomPresenter } from "../pb/pb"

type DiscountCardPresentParams = Parameters<typeof CustomPresenter.GetLuckDiscountCardDrawStatus>[0]
type DiscountCardCoupon = Parameters<typeof CustomPresenter.ExecLuckDiscountCardPresent>[0]
export function getDiscountCardAndCouponStatus(params: DiscountCardPresentParams, loginState: any) {
  return CustomPresenter.GetLuckDiscountCardDrawStatus(params, loginState)
}

export function receiveDiscountCardCoupon(params: DiscountCardCoupon, loginState: any) {
  return CustomPresenter.ExecLuckDiscountCardPresent(params, loginState)
}
